import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import TextField from "../Form/TextField";
import { MAX_BUSINESS_COMPETITORS } from "../../utils/constants";

const CompetitorsEditor = ({
  control,
  errors,
  watch,
  setValue,
  businessCompetitorsFields,
  appendBusinessCompetitors,
  removeBusinessCompetitors,
  validationRules,
}) => {
  const businessCompetitors = watch("businessCompetitors") || [];
  const newCompetitor = watch("newCompetitor") || "";
  const isMaxReached =
    businessCompetitorsFields.length >= MAX_BUSINESS_COMPETITORS;

  const onAddCompetitor = () => {
    if (isMaxReached) return;

    const trimmedCompetitor = newCompetitor.trim();
    if (trimmedCompetitor && !businessCompetitors.includes(trimmedCompetitor)) {
      appendBusinessCompetitors(trimmedCompetitor);
      setValue("newCompetitor", "");
    }
  };

  const onRemoveCompetitor = (index) => {
    removeBusinessCompetitors(index);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      {businessCompetitorsFields.map((field, index) => (
        <Box
          key={field.id}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <TextField
            variant="filled"
            control={control}
            name={`businessCompetitors.${index}`}
            rules={validationRules.businessCompetitors}
            errors={errors}
            fullWidth
            sx={{
              "& .MuiInputBase-input": {
                height: "40px",
              },
            }}
          />
          <IconButton
            size="small"
            onClick={() => onRemoveCompetitor(index)}
            sx={{
              width: 40,
              height: 40,
              color: "text.primary",
              flexShrink: 0,
              "&:hover": {
                backgroundColor: "action.hover",
              },
            }}
          >
            <DeleteIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>
      ))}

      {!isMaxReached ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <TextField
            control={control}
            name="newCompetitor"
            fullWidth
            variant="filled"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onAddCompetitor();
              }
            }}
            sx={{
              "& .MuiInputBase-input": {
                height: "40px",
              },
            }}
            rules={{ required: false }}
          />
          <IconButton
            size="small"
            onClick={onAddCompetitor}
            disabled={
              !newCompetitor.trim() ||
              businessCompetitors.includes(newCompetitor.trim())
            }
            sx={{
              width: 40,
              height: 40,
              color: "text.primary",
              flexShrink: 0,
              "&:hover": {
                backgroundColor: "action.hover",
              },
              "&.Mui-disabled": {
                opacity: 0.5,
              },
            }}
          >
            <AddIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>
      ) : null}
    </Box>
  );
};

export default CompetitorsEditor;
